import { Injectable, TemplateRef } from '@angular/core';
import { OverlayService, ModalDefinition } from '../../../../services/overlay.service';

@Injectable()
export class InteractivityDataSourceService {
	private _dataSourceModel: any;
	private _dataSourceConfig: ModalDefinition;

	constructor(protected overlayService: OverlayService) {
	}

	set dataSourceModel(model: any) {
		this._dataSourceModel = model;
	}

	get dataSourceModel() {
		return this._dataSourceModel;
	}

	get dataSourceConfig() {
		return this._dataSourceConfig;
	}

	onDataSourceClicked(model: any, dataSourceTemplate: TemplateRef<any>) {
		this.dataSourceModel = model;

		this._dataSourceConfig = {
			icon: 'fa-plug',
			title: 'Select a source to fill this field from',
			component: {
				theme: 'dark-theme',
				name: 'custom-content',
				templateRef: dataSourceTemplate
			}
		};
		this.overlayService.createModal(this.dataSourceConfig);
	}

	onDataPickerClosed() {
		// console.warn('closed');
	}

	onDataSourceRemove(newValue: any, valueType: string = 'value', del = false) {
		if (del) {
			delete this.dataSourceModel[valueType];
		} else if (typeof newValue[valueType] !== 'string') {
			this.dataSourceModel[valueType] = (newValue && newValue[valueType].datasource && newValue[valueType].datasource.defaultValue)
				? newValue[valueType].datasource.defaultValue
				: '';
		} else {
			this.dataSourceModel[valueType] = newValue[valueType];
		}
		this.closeModal();
	}

	onDataSourceOk(newValue: any, valueType: string = 'value') {
		this.dataSourceModel[valueType] = { ...newValue[valueType] };
		this.closeModal();
	}

	onDataSourceCancel(ev: any) {
		this.closeModal();
	}

	closeModal(): void {
		if (this.dataSourceConfig) {
			this.overlayService.removeModal(this.dataSourceConfig);
		}
	}
}
